<template>
  <div class="relative text-white overflow-hidden h-full w-full rounded-lg border border-gray-800 shadow-lg">
    <iframe
      class="w-full h-full"
      :src="url"
      height="1080"
      width="1920"
    />
  </div>
</template>

<script lang="ts" setup>
import type { DeepReadonly, PropType } from 'vue'
import type { DeckUser } from '@/entities/deck'

const emit = defineEmits(['goto:page', 'update:image-dimensions'])

const props = defineProps({
  url: {
    type: String,
    required: true,
  },
  user: {
    type: Object as PropType<DeepReadonly<DeckUser>>,
    default: () => ({}),
  },
})

const isInSession = computed(() => props.user.deckUserType === 'controlled')
</script>
